module.exports = __webpack_public_path__ + "img/shield-user-line.c8490083.svg";